/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Platform styles
import "@/styles/main.scss";

// Plugins
import vuetify from "./vuetify";
import { createPinia } from "pinia";
import createAppRouter from "../router";
import initI18n from "./i18n";
import VueCookies from "vue-cookies";
import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'
import { BugsnagConfig } from '../../src/bugsnagConfig'
import appConfig from '../../src/constants/appConfig'
import Clarity from '@microsoft/clarity';

// Types
import type { App } from "vue";
import type { IApp } from "@/types/app";

export function registerPlugins(app: App) {
  /**
   * Register plugins
   */
  BugsnagConfig.configure();
  BugsnagPerformance.start({ apiKey: appConfig.bugsnagApiKey });

  const projectId = 'qyt6b6tdtb';
  if (import.meta.env.VITE_ENV === 'testing') {
    Clarity.init(projectId);
  }

  app.use(VueCookies, { expires: "30d", secure: true });
  app
    .use(createPinia())
    .use(vuetify)
    .use(createAppRouter())
    .use(initI18n(app as IApp));
  const bugsnagVue = Bugsnag.getPlugin('vue');
  if (bugsnagVue) {
    app.use(bugsnagVue);
  }
}
